import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
    selector: 'app-dashboard-widget-card',
    templateUrl: './dashboard-widget-card.component.html',
    host: { class: 'block h-full min-w-0' },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardWidgetCardComponent {
    @Input() title = '';
    @Input() eyebrow = '';
    @Input() subtitle = '';
    @Input() icon: IconProp | null = null;
    @Input() variant: 'default' | 'built-in' | 'report' | 'warning' | string = 'default';
    @Input() loading = false;
    @Input() empty = false;
    @Input() errorCount = 0;
    @Input() compact = false;
    @Input() editing = false;
    @Input() clickable = false;
}
